import { UserDetailsContext } from 'App';
import { DEFAULT_FAVICON_URL, DEFAULT_LOGO_URL, IMAGE_URL, PRODUCT_ID } from 'common-ui-components/components/utils/Config';
import { links } from 'HelpLinks';
import React, { useContext, useEffect, useState } from 'react';
import styles from "./Root.module.css";
import { useLocation } from 'react-router-dom';

const RootNavbarLogoFavicon = () => {
    const location = useLocation();
    const userDetails = useContext(UserDetailsContext);
    const customerRebrandingList = userDetails?.rebranding || [];
    const currentCustomerId = userDetails?.currentCustomerId;

    const [currentCustomer, setCurrentCustomer] = useState(null);

    useEffect(() => {
        const foundCustomer = customerRebrandingList.find(
            item => String(item.customerId) === String(currentCustomerId)
        );
        setCurrentCustomer(foundCustomer || null);
    }, [currentCustomerId, customerRebrandingList]);

    const logoUpdatedAt = currentCustomer?.logoUpdatedAt || userDetails.logoUpdatedAt;
    const logoKey = currentCustomer?.logoKey || userDetails.logoKey;
    const logoUrl = logoUpdatedAt && logoUpdatedAt !== ""
            ? `${IMAGE_URL}?type=logo&v=${logoUpdatedAt}&key=${logoKey}&productId=${PRODUCT_ID}`
            : DEFAULT_LOGO_URL;

    const faviconUpdatedAt = currentCustomer?.faviconUpdatedAt || userDetails.faviconUpdatedAt;
    const faviconKey = currentCustomer?.faviconKey || userDetails.faviconKey;
    const faviconUrl = faviconUpdatedAt && faviconUpdatedAt !== ""
        ? `${IMAGE_URL}?type=favicon&v=${faviconUpdatedAt}&key=${faviconKey}&productId=${PRODUCT_ID}`
        : DEFAULT_FAVICON_URL;
    
    // function to update icon dynamically
    const updateFavicon = (href) => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) 
        {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        link.href = href;
    };
    
    //updates favicon on userDetails and route changes
    useEffect(() => {
        if ("favIconPicture" in userDetails) 
        {
            const favicon = userDetails.favIconPicture;
            if (favicon) 
                updateFavicon(favicon);
            else 
                updateFavicon(DEFAULT_FAVICON_URL);
        } 
        else 
            updateFavicon(faviconUrl);
    }, [userDetails, location.pathname]);

    const redirectToCompany = (url) => {
        if (url) window.open(url, "_blank");
    };

    return (
        <>
            {(() => {
                if ("logoPicture" in userDetails) 
                {
                    if (userDetails.logoPicture)
                        return (
                            <img
                                className={styles.zecuritLogo}
                                src={userDetails.logoPicture}
                                alt="Logo"
                                onClick={() => redirectToCompany(userDetails.companyUrl)}
                            />
                        );
                    else
                        return (
                            <img
                                className={styles.zecuritLogo}
                                src={DEFAULT_LOGO_URL}
                                alt="Logo"
                                onClick={() => redirectToCompany(links.zecurit)}
                            />
                        );
                }
                return (
                    <img
                        className={styles.zecuritLogo}
                        src={logoUrl}
                        alt="Logo"
                        onClick={() =>
                        redirectToCompany(
                            logoUrl === DEFAULT_LOGO_URL ? links.zecurit : userDetails.companyUrl
                        )
                        }
                    />
                );
            })()}
        </>
    );
};

export default RootNavbarLogoFavicon;